import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Carousel, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ShoppingCart, MessageSquare, Users, BookOpenText, Trophy, Laptop } from 'lucide-react'; // Example icons
import Footer from '../components/Footer';
import './home.css'; // Assuming you have a CSS file for custom styles

// Mock data (replace with API calls in a real app)
const mockProducts = [
  // { id: 1, name: 'E-Book', description: 'Essential Guide to Laparoscopic Cholecystectomy Surgery: Techniques for Surgical Excellence', price: '$9.99', imageUrl: 'https://picsum.photos/300/200', link: '/' },
  { id: 2, name: 'Surgery Walkthorugh', description: 'Mobile App for Surgeons to visually learn and practice laparoscopic surgery', price: '$19.99', imageUrl: 'https://picsum.photos/300/200', link: '/' },
  { id: 3, name: 'Surgery Simulator', description: 'Surgery simulator for realistic surgical exercises and case study trainings', price: '$99.99', imageUrl: 'https://picsum.photos/300/200', link: '/' },
];

const mockTestimonials = [
  { id: 1, quote: "The faculty’s expertise and the advanced facilities make this a premier institution for surgical training.", author: "General Surgeon", company: "" },
  { id: 2, quote: "The training at B.E.S.T Institute has been a transformative experience. The hands-on sessions were particularly valuable.", author: "Gynecologist", company: "" },
];

// Helper component for feature sections (optional)
const FeatureCard = ({ icon, title, text }) => (
  <Col md={3} className="mb-4">
    <Card className="h-100 text-center shadow-sm border-light">
      <Card.Body>
        <div className="mb-3 text-primary">{icon}</div>
        <Card.Title as="h4" className="mb-3">{title}</Card.Title>
        <Card.Text className="text-muted">{text}</Card.Text>
      </Card.Body>
    </Card>
  </Col>
);


const Home = () => {
  const [products, setProducts] = useState([]);
  const [testimonials] = useState(mockTestimonials); // Using mock data directly

  useEffect(() => {
    // Simulate fetching products
    // In a real app, you'd make an API call here:
    // axiosInstance.get('/api/products')
    //   .then(response => setProducts(response.data.results || response.data))
    //   .catch(error => console.error("Error fetching products:", error));
    setProducts(mockProducts);
  }, []);

  return (
    <>
      {/* 1. Full-width Hero Image Section */}
      <div className="hero-section text-center text-white" style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/static/OT-Surgery-3-scaled.webp')`, // Replace with your hero image
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '100px 0',
        minHeight: '50vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <Container>
          <h1 className="display-3 font-weight-bold mb-4">Empowering Surgeons, Advancing Healthcare</h1>
          <p className="lead mb-5" style={{ maxWidth: '700px', margin: '0 auto 2rem auto' }}>
            Leaders in Laparoscopic Surgery Training
          </p>
          <div>
            <Link to="/register">
              <Button variant="primary" size="lg" className="me-3 px-5 py-3">Get Started</Button>
            </Link>
            <Link to="/training-programs"> {/* Or any other relevant link */}
              <Button variant="outline-light" size="lg" className="px-5 py-3">Learn More</Button>
            </Link>
          </div>
        </Container>
      </div>

      {/* 2. Introductory Paragraph Section */}
      <Container className="my-5 py-5">
        <Row className="justify-content-center">
          <Col md={8} className="text-center">
            <h2 className="mb-4 display-5 font-weight-normal">Welcome to B.E.S.T Institute & Research Centre</h2>
            <p className="lead text-muted">
              Founded in 1998, the Bangalore Endoscopic Surgery, Training Institute, and Research Centre has been at the forefront of surgical education and research. With state-of-the-art facilities and a team of seasoned professionals, we are committed to advancing the field of laparoscopic surgery through comprehensive training and high-impact research.
            </p>
            <hr style={{ width: '80px', margin: '2rem auto', borderWidth: '2px', borderColor: '#0d6efd' }} />
          </Col>
        </Row>

        <div className="stats-banner">
      <Container>
        <Row className="text-center text-white">
          {/* First Stat Item */}
          <Col md={6} className="mb-4 mb-md-0">
            <p className="stats-label">Students</p>
            <h2 className="stats-number">2000+</h2>
            <p className="stats-description">surgeons trained from across the globe</p>
          </Col>

          {/* Second Stat Item */}
          <Col md={6}>
            <p className="stats-label">Training & Courses</p>
            <h2 className="stats-number">6+</h2>
            <p className="stats-description">Throughout the world</p>
          </Col>
        </Row>
      </Container>
    </div>

        {/* Feature Highlights Section (Optional Bonus) */}
        <Row className="mt-5 justify-content-md-center">
          <FeatureCard
            icon={<Users size={48} className="mb-3" />}
            title="World-Class Faculty Led by Industry Pioneers"
            text="Train under the direct guidance of Dr. Makam Ramesh's Team of renowned laparoscopic surgeon with decades of experience and international exposure. Benefit from their expertise and insights to gain a well-rounded education in laparoscopic surgery."
          />
          <FeatureCard
            icon={<BookOpenText size={48} className="mb-3" />}
            title="Comprehensive and Updated Curriculum"
            text="Our training programs are meticulously designed to cover the breadth and depth of laparoscopic surgery. From basic techniques to advanced procedures, the curriculum is continually updated to include the latest surgical techniques and technologies, ensuring you stay at the forefront of your field."
          />
          <FeatureCard
            icon={<Trophy size={48} className="mb-3" />}
            title="State-of-the-Art Training Facilities"
            text="B.E.S.T Institute boasts cutting-edge training facilities featuring specialized Endo Trainers,high-fidelity simulators and Virtual Reality platforms. Our hands-on training modules ensure that you acquire the practical skills needed to excel in real-world surgical scenarios."
          />
          <FeatureCard
            icon={<Laptop size={48} className="mb-3" />}
            title="Hybrid Training Options: Online and In-Person Workshops"
            text="We will be offer the flexibility of both online and in-person training sessions, allowing you to learn at your own pace and convenience. This hybrid model ensures that even if you cannot attend in person, you can still benefit from our world-class training programs."
          />
        </Row>
      </Container>

      {/* 3. Testimonials Section */}
      <div className="bg-light py-5 my-3">
        <Container className="py-5">
          <h2 className="text-center mb-5 display-5 font-weight-normal">What Our Users Say</h2>
          {/* If using Carousel for testimonials */}
          <Carousel indicators={false} interval={5000}>
            {testimonials.map(testimonial => (
              <Carousel.Item key={testimonial.id}>
                <div className="d-flex justify-content-center">
                  <Col md={8} lg={6}>
                    <Card className="text-center p-4 border-0 shadow-lg bg-white">
                      <MessageSquare size={32} className="text-primary mx-auto mb-3" />
                      <p className="lead fst-italic">"{testimonial.quote}"</p>
                      <p className="mt-3 mb-0 fw-bold">{testimonial.author}</p>
                    </Card>
                  </Col>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </Container>
      </div>

      {/* 4. Product Cards Section */}
      <Container className="my-5 py-5">
        <h2 className="text-center mb-5 display-5 font-weight-normal">Our Offerings</h2>
        <Row>
          <Col md={4} key={1} className="mb-4 d-flex align-items-stretch">
            <Card className="shadow-sm hover-shadow h-100 w-100 border-light"> {/* Added custom class for transition */}
              {/* <Card.Img 
                    variant="top"
                    src={""}
                    alt={"Essential Guide to Laparoscopic Cholecystectomy Surgery: Techniques for Surgical Excellence"}
                    style={{ 
                        backgroundColor: '#E9ECEF', // A fallback color in case the image link breaks
                        height: '250px', // A fixed height ensures all cards in a row have the same image height
                        objectFit: 'cover' // This will cover the area without distorting the aspect ratio
                    }} 
                /> */}
              <Card.Body className="d-flex flex-column">
                <Card.Title as="h4" className="mb-2">E-Book</Card.Title>
                <Card.Text className="text-muted mb-3 flex-grow-1">
                  Essential Guide to Laparoscopic Cholecystectomy Surgery: Techniques for Surgical Excellence
                </Card.Text>
                <Card.Text className="h5 font-weight-bold mb-3">$9.99</Card.Text>
                <Link to={`/books/`}>
                  <Button variant="primary" className="w-100 mt-auto">
                    <ShoppingCart size={18} className="me-2" /> Read
                  </Button>
                </Link>
              </Card.Body>
            </Card>
          </Col>
          {products.length > 0 ? (
            products.map(product => (
              <Col md={4} key={product.id} className="mb-4 d-flex align-items-stretch">
                <Card className="shadow-sm hover-shadow h-100 w-100 border-light"> {/* Added custom class for transition */}
                  {/* <Card.Img variant="top" src={product.imageUrl || 'https://picsum.photos/300/200'} /> */}
                  <Card.Body className="d-flex flex-column">
                    <Card.Title as="h4" className="mb-2">{product.name}</Card.Title>
                    <Card.Text className="text-muted mb-3 flex-grow-1">
                      {product.description}
                    </Card.Text>
                    <Card.Text className="h5 font-weight-bold mb-3">{product.price}</Card.Text>
                    <Link to={product.link || `/products/${product.id}`}>
                      <Button variant="primary" className="w-100 mt-auto" disabled>
                        <ShoppingCart size={18} className="me-2" /> Coming Soon
                      </Button>
                    </Link>
                  </Card.Body>
                </Card>
              </Col>
            ))
          ) : (
            <Col className="text-center">
              <Spinner animation="border" variant="primary" className="me-2" />
              <p className="text-muted d-inline">Loading products...</p>
            </Col>
          )}
        </Row>
      </Container>

      <Footer />

    </>
  );
};

export default Home;